export default "__VITE_ASSET__nr7xGokD__"